/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingPlacementRqDto } from './traveline-booking-placement-rq-dto';
import {
    TravelineBookingPlacementRqDtoFromJSON,
    TravelineBookingPlacementRqDtoFromJSONTyped,
    TravelineBookingPlacementRqDtoToJSON,
    TravelineBookingPlacementRqDtoToJSONTyped,
} from './traveline-booking-placement-rq-dto';

/**
 * Room type entity
 * @export
 * @interface TravelineBookingRoomTypeRqDto
 */
export interface TravelineBookingRoomTypeRqDto {
    /**
     * Room type ID
     * @type {string}
     * @memberof TravelineBookingRoomTypeRqDto
     */
    id: string;
    /**
     * Accommodations entity
     * @type {Array<TravelineBookingPlacementRqDto>}
     * @memberof TravelineBookingRoomTypeRqDto
     */
    placements: Array<TravelineBookingPlacementRqDto>;
}

/**
 * Check if a given object implements the TravelineBookingRoomTypeRqDto interface.
 */
export function instanceOfTravelineBookingRoomTypeRqDto(value: object): value is TravelineBookingRoomTypeRqDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('placements' in value) || value['placements'] === undefined) return false;
    return true;
}

export function TravelineBookingRoomTypeRqDtoFromJSON(json: any): TravelineBookingRoomTypeRqDto {
    return TravelineBookingRoomTypeRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingRoomTypeRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRoomTypeRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'placements': ((json['placements'] as Array<any>).map(TravelineBookingPlacementRqDtoFromJSON)),
    };
}

  export function TravelineBookingRoomTypeRqDtoToJSON(json: any): TravelineBookingRoomTypeRqDto {
      return TravelineBookingRoomTypeRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRoomTypeRqDtoToJSONTyped(value?: TravelineBookingRoomTypeRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'placements': ((value['placements'] as Array<any>).map(TravelineBookingPlacementRqDtoToJSON)),
    };
}

